import * as dateFnsLocales from 'date-fns/locale';
import type { Locale } from 'date-fns';

export function getBrowserDateFnsLocale(): Locale {
  const lang = navigator.language;
  const key = lang.replace(/-(\w)/g, (_, c: string) => c.toUpperCase()); // e.g. "en-US" → "enUS"
  return (
    (dateFnsLocales as Record<string, Locale>)[key] ?? (dateFnsLocales as Record<string, Locale>)[lang.split('-')[0]] ?? dateFnsLocales.enUS
  );
}
